export function delay(time){
    return (inner) => new Promise((resolve) => setTimeout(() => resolve(inner), time));
}